module.exports = __webpack_public_path__ + "img/NKFIA_infoblokk_kerettel_projekt_fekvo_2019_HU_small.c8f26585.png";